import { Value } from '@features/product/components/Collection/Collection.types';
import { AvailabilityState } from '@features/product/typings';
import { getCollectionProductImageId } from '@utils/collectionUtils/getCollectionProductImageId';

export const getCollectionProductInfo = (value: Value, productsWithCurrentColor: number[]) => {
  const filteredProducts = value.products.filter(
    product => product?.nullableAvailabilityState !== AvailabilityState.OutOfStock
  );

  const product =
    filteredProducts.find(product =>
      product ? productsWithCurrentColor.includes(product.id) : false
    ) ?? filteredProducts[0];

  const productImageId = getCollectionProductImageId(product);
  const availabilityState = product?.nullableAvailabilityState;

  return { productImageId, availabilityState };
};
